// PDP / featured-product JS. Subscribe-interval console logs: set window.__DEBUG_SUBSCRIBE_INTERVAL_CARDS = true then reload.

// Toggle dropdown
document.querySelectorAll('.c-sticky-atc .dropdown-select').forEach(el => {
  el.addEventListener('click', e => {
    e.stopPropagation(); // Prevent outside click from firing
    const parent = el.closest('.c-sticky-atc');

    // Close other open dropdowns
    parent.querySelectorAll('.dropdown-select.exp').forEach(openEl => {
      if (openEl !== el) openEl.classList.remove('exp');
    });

    // Toggle current dropdown
    el.classList.toggle('exp');
  });
});

// Close dropdown when clicking outside
document.addEventListener('click', e => {
  document.querySelectorAll('.c-sticky-atc .dropdown-select.exp').forEach(openEl => {
    if (!openEl.contains(e.target)) {
      openEl.classList.remove('exp');
    }
  });
});

// Handle label click inside dropdown
document.querySelectorAll('.c-sticky-atc .dropdown-options label').forEach(label => {
  label.addEventListener('click', e => {
    e.stopPropagation(); // Prevent reopening

    // Get the parent dropdown
    const dropdown = label.closest('.dropdown-select');
    if (!dropdown) return;

    // Get data-selling-plan-name from parent <li>
    const li = label.closest('li');
    const planName = li?.dataset.sellingPlanName || '(no data-selling-plan-name found)';
    

    // Trigger corresponding input click (vanilla JS)
    if (planName === 'one-time') {
      const oneTimeInput = document.querySelector('.product-subscriptions [data-frequency="One-time"]');
      if (oneTimeInput) oneTimeInput.closest('label').click();
    } else {
      const planInput = document.querySelector(`.product-subscriptions [data-selling-plan-name="${planName}"] label`);
      if (planInput) planInput.click();
    }

    // Get new title & price text
    const newTitle = label.querySelector('.product-subscriptions__subscription-label')?.textContent.trim() || '';
    const newPrice = label.querySelector('.product-subscriptions__subscription-price')?.innerHTML || '';

    // Replace displayed values
    const titleEl = dropdown.querySelector('.dropdown-selected__title');
    const priceEl = dropdown.querySelector('.dropdown-selected__price-per-serving');

    if (titleEl) titleEl.textContent = newTitle;
    if (priceEl) priceEl.innerHTML = newPrice;

    // Close the dropdown
    dropdown.classList.remove('exp');
  });
});



// Event delegation for dynamically added buttons
document.body.addEventListener('click', function(e) {
  const target = e.target.closest('.c-sticky-atc .button');
  if (!target) return;

  // Find all buy buttons and trigger click
  document.querySelectorAll('.product-info .buy-buttons .button').forEach(btn => {
    btn.click();
  });
});




// Show/hide sticky buy buttons on scroll with opacity transition
(function() {
  const stickyButtons = document.querySelector('[data-product-buy-buttons-sticky]');
  const storeHeader = document.querySelector('[data-store-header]');
  const announcementBar = document.querySelector('[data-announcement-bar]');
  
  if (!stickyButtons) return;

  const scrollThreshold = 100; // Show after scrolling 100px down
  let lastScrollY = window.scrollY;

  function handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > scrollThreshold) {
      // User has scrolled down - fade in sticky buttons, fade out header/announcement
      stickyButtons.classList.remove('is-hidden');
      stickyButtons.style.opacity = '1';
      
      if (storeHeader) {
        storeHeader.style.opacity = '0';
      }
      if (announcementBar) {
        announcementBar.style.opacity = '0';
      }
    } else {
      // User is near the top - fade out sticky buttons, fade in header/announcement
      stickyButtons.style.opacity = '0';
      // Add is-hidden class after transition completes
      setTimeout(() => {
        if (window.scrollY <= scrollThreshold) {
          stickyButtons.classList.add('is-hidden');
        }
      }, 300); // Match CSS transition duration
      
      if (storeHeader) {
        storeHeader.style.opacity = '1';
      }
      if (announcementBar) {
        announcementBar.style.opacity = '1';
      }
    }

    lastScrollY = currentScrollY;
  }

  // Initial check - start with opacity 0 for sticky buttons
  stickyButtons.style.opacity = '0';
  handleScroll();

  // Throttle scroll events for better performance
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
})();

/**
 * Subscribe interval cards are rendered for the initial selected format only.
 * When the customer changes format (e.g. Pouch → Travel Sachets), refresh each
 * interval row from Liquid-provided JSON so prices and variant metafields match.
 */
(function () {
  /** `window.__DEBUG_SUBSCRIBE_INTERVAL_CARDS = true` enables subscribe-interval console logs. */
  var SUBSCRIBE_DEBUG =
    typeof window !== 'undefined' && window.__DEBUG_SUBSCRIBE_INTERVAL_CARDS === true;

  function logSubscribe() {
    if (!SUBSCRIBE_DEBUG) return;
    var a = ['[subscribe-interval-cards]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, a);
  }

  function variantWithOptions(picker, variant) {
    if (!variant || !picker?.product?.variants) return variant;
    let v = picker.product.variants.find(function (x) {
      return String(x.id) === String(variant.id);
    });
    if (!v) return variant;
    if (Array.isArray(v.options) && v.options.length) return v;
    const opts = [];
    for (let i = 1; i <= 3; i++) {
      const key = 'option' + i;
      if (v[key] != null && v[key] !== '') opts.push(v[key]);
    }
    v = Object.assign({}, v, { options: opts });
    return v;
  }

  /**
   * Real form id string. Do not use `form.id` — on HTMLFormElement it is shadowed by a control
   * named `id` (the hidden variant input), so `form.id` returns that input, not the form's id string.
   */
  function formIdAttr(form) {
    return form && form.getAttribute ? form.getAttribute('id') || '' : '';
  }

  /** Subscribe UI lives inside <variant-picker>, not inside <form> (form is in buy-buttons). */
  function getPickerAndSubscribeRoot(form) {
    const fid = formIdAttr(form);
    if (!form || !fid) return { picker: null, root: null };
    const picker = document.querySelector('variant-picker[form="' + fid + '"]');
    const root = picker ? picker.querySelector('.subscribe-interval-cards') : null;
    return { picker: picker, root: root };
  }

  function syncSubscribeIntervalCardsUi(variant, form, source) {
    source = source || 'sync';
    if (!variant || !form) {
      logSubscribe('abort (' + source + '): missing variant or form', { variant: !!variant, form: !!form });
      return;
    }
    const pr = getPickerAndSubscribeRoot(form);
    const root = pr.root;
    const picker = pr.picker;
    if (!root || !picker?.product?.variants) {
      logSubscribe('abort (' + source + '): no .subscribe-interval-cards or picker/variants', {
        hasRoot: !!root,
        hasPicker: !!picker,
        variantCount: picker?.product?.variants?.length,
        note: 'subscribe UI is under variant-picker, not inside product form'
      });
      return;
    }

    variant = variantWithOptions(picker, variant);
    logSubscribe('start (' + source + ')', {
      variantId: variant.id,
      options: variant.options,
      formId: formIdAttr(form),
      masterValue: picker.masterSelector && picker.masterSelector.value,
      masterSelectorType: picker.masterSelector ? typeof picker.masterSelector : 'none'
    });

    const vp = root.closest('variant-picker');
    const uiScript =
      (vp && vp.querySelector('script[data-subscribe-interval-cards-ui]')) ||
      document.querySelector('script[data-subscribe-interval-cards-ui]');
    if (!uiScript) {
      logSubscribe('abort (' + source + '): no script[data-subscribe-interval-cards-ui]');
      return;
    }

    let data;
    try {
      data = JSON.parse(uiScript.textContent);
    } catch (e) {
      logSubscribe('abort (' + source + '): JSON parse error', e && e.message, uiScript.textContent.slice(0, 200));
      return;
    }
    const byVariantId = data.byVariantId;
    const formatIdx = parseInt(root.dataset.formatOptionIndex, 10);
    const intervalIdx = parseInt(root.dataset.intervalOptionIndex, 10);
    if (Number.isNaN(intervalIdx)) {
      logSubscribe('abort (' + source + '): bad data-interval-option-index', {
        intervalOptionIndex: root.dataset.intervalOptionIndex
      });
      return;
    }
    const hasFormat = !Number.isNaN(formatIdx) && formatIdx >= 0;

    const newFormat = hasFormat ? variant.options[formatIdx] : null;
    if (hasFormat && newFormat == null) {
      logSubscribe('abort (' + source + '): variant.options[' + formatIdx + '] is null/undefined', {
        options: variant.options,
        length: variant.options && variant.options.length
      });
      return;
    }

    logSubscribe('indices', { formatIdx: formatIdx, intervalIdx: intervalIdx, newFormat: newFormat, hasFormat: hasFormat });
    var rowLog = [];

    root.querySelectorAll('.subscribe-interval-cards__item').forEach(function (item) {
      const input = item.querySelector('input[type="radio"][name^="option"]');
      if (!input) return;
      const intervalVal = input.value;
      const rowVariant = picker.product.variants.find(function (v) {
        if (!v.options) return false;
        const matchesFormat = hasFormat ? v.options[formatIdx] === newFormat : true;
        return matchesFormat && v.options[intervalIdx] === intervalVal;
      });
      const label = item.querySelector('label.subscribe-card');
      if (!label) return;

      const sid = rowVariant ? String(rowVariant.id) : null;
      const ui = sid && byVariantId[sid] ? byVariantId[sid] : null;

      rowLog.push({
        intervalVal: intervalVal,
        rowVariantId: sid,
        hasUiJson: !!ui,
        variantAvailable: !!(rowVariant && rowVariant.available),
        disabled: ui && ui.disabled,
        bulletCount: ui && ui.bullets ? ui.bullets.length : 0
      });

      // Interval / frequency cards should NOT switch to a "Unavailable" state
      // based on inventory — they always retain their original price/messaging.
      // Only data-disabled cards (ui.disabled) or missing data should disable
      // the card. Out-of-stock handling for these variants is the ATC button's
      // job (it swaps to the back-in-stock waitlist when inventory is 0).
      if (!rowVariant || !ui || ui.disabled) {
        input.disabled = true;
        input.removeAttribute('data-selling-plan-id');
        input.checked = false;
        label.classList.add('subscribe-card--disabled');
        label.classList.add('is-sold-out');
        const priceBlock = label.querySelector('.subscribe-card__price-block');
        if (priceBlock) {
          priceBlock.innerHTML = '<p class="subscribe-card__price text-subdued">Unavailable</p>';
        }
        return;
      }

      label.classList.remove('subscribe-card--disabled');
      label.classList.remove('is-sold-out');
      input.disabled = false;
      if (ui.sellingPlanId != null && ui.sellingPlanId !== '') {
        input.setAttribute('data-selling-plan-id', String(ui.sellingPlanId));
      } else {
        input.removeAttribute('data-selling-plan-id');
      }

      // Keep Skio data attributes in sync after format / variant changes so
      // skio-line-item-properties.js picks up the right values on the next
      // radio change.
      input.setAttribute('data-skio-group', ui.skioGroupId != null ? String(ui.skioGroupId) : '');
      input.setAttribute('data-skio-freq', ui.skioFreq != null ? String(ui.skioFreq) : '');
      input.setAttribute('data-skio-unit', ui.skioUnit != null ? String(ui.skioUnit) : '');
      input.setAttribute('data-skio-discount', ui.skioDiscount != null ? String(ui.skioDiscount) : '');

      let badgeEl = label.querySelector('.subscribe-card__badge');
      if (ui.badgeText) {
        if (!badgeEl) {
          badgeEl = document.createElement('span');
          badgeEl.className = 'subscribe-card__badge';
          const main = label.querySelector('.subscribe-card__main');
          if (main) {
            label.insertBefore(badgeEl, main);
          } else {
            label.insertBefore(badgeEl, label.firstChild);
          }
        }
        badgeEl.textContent = ui.badgeText;
        if (ui.badgeStyle) {
          badgeEl.setAttribute('style', ui.badgeStyle);
        } else {
          badgeEl.removeAttribute('style');
        }
        badgeEl.style.display = '';
      } else if (badgeEl) {
        badgeEl.remove();
      }

      const titleWrap = label.querySelector('.subscribe-card__title');
      let discountEl = label.querySelector('.subscribe-card__discount');
      if (ui.discountText) {
        if (!discountEl && titleWrap) {
          discountEl = document.createElement('span');
          discountEl.className = 'subscribe-card__discount';
          titleWrap.appendChild(discountEl);
        }
        if (discountEl) {
          discountEl.textContent = ui.discountText;
          if (ui.discountColor) {
            discountEl.style.color = ui.discountColor;
          } else {
            discountEl.style.color = '';
          }
        }
      } else if (discountEl) {
        discountEl.remove();
      }

      const subEl = label.querySelector('.subscribe-card__subtitle');
      if (subEl) {
        subEl.textContent = ui.subtitle || '';
        if (ui.subtitle) {
          subEl.removeAttribute('hidden');
          subEl.style.display = '';
        } else {
          subEl.setAttribute('hidden', '');
        }
      }

      let bulletsWrap = label.querySelector('.subscribe-card__bullets');
      if (!bulletsWrap) {
        const copy = label.querySelector('.subscribe-card__copy');
        const titleEl = copy && copy.querySelector('.subscribe-card__title');
        if (copy && titleEl) {
          bulletsWrap = document.createElement('ul');
          bulletsWrap.className = 'subscribe-card__bullets';
          bulletsWrap.setAttribute('role', 'list');
          titleEl.insertAdjacentElement('afterend', bulletsWrap);
        }
      }
      if (bulletsWrap) {
        bulletsWrap.innerHTML = '';
        if (ui.bullets && ui.bullets.length) {
          ui.bullets.forEach(function (line) {
            if (!line) return;
            const li = document.createElement('li');
            li.className = 'subscribe-card__bullet';
            li.textContent = line;
            bulletsWrap.appendChild(li);
          });
          bulletsWrap.removeAttribute('hidden');
          bulletsWrap.style.display = '';
        } else {
          bulletsWrap.setAttribute('hidden', '');
          bulletsWrap.style.display = '';
        }
      }

      const priceBlock = label.querySelector('.subscribe-card__price-block');
      if (priceBlock && ui.price) {
        let compareHtml = '';
        if (ui.compare) {
          compareHtml =
            '<span class="subscribe-card__compare-wrap"><s class="subscribe-card__compare">' +
            ui.compare +
            '</s><span class="subscribe-card__per-mo"></span></span>';
        }
        let perServingHtml = '';
        if (ui.perServing) {
          perServingHtml =
            '<p class="subscribe-card__per-serving text-subdued">' + ui.perServing + '</p>';
        }
        priceBlock.innerHTML =
          '<p class="subscribe-card__price-row">' +
          '<span class="subscribe-card__price">' +
          ui.price +
          '</span>' +
          compareHtml +
          '</p>' +
          perServingHtml;
      }
    });

    const curInterval = variant.options[intervalIdx];
    let matched = false;
    root.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      const ok = inp.value === curInterval && !inp.disabled;
      inp.checked = ok;
      if (ok) matched = true;
    });
    if (!matched) {
      const firstEnabled = root.querySelector('input[type="radio"]:not(:disabled)');
      if (firstEnabled) {
        firstEnabled.checked = true;
        // Keep VariantPicker + hidden id input in sync when fallback interval is auto-selected.
        firstEnabled.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const firstAny = root.querySelector('input[type="radio"]');
        // If all intervals are disabled, still keep a checked value to avoid null selector lookups.
        if (firstAny) firstAny.checked = true;
      }
    }

    logSubscribe('done (' + source + ')', {
      curInterval: curInterval,
      matchedRadio: matched,
      rows: rowLog
    });

    // Defer so variant:change can finish (bubble phase: sale price, etc.). Sync dispatch during capture
    // could throw and abort propagation; listener errors must not break PDP updates.
    const formRef = form;
    queueMicrotask(function () {
      try {
        formRef.dispatchEvent(new CustomEvent('subscribe-interval-cards:sync', { bubbles: true }));
      } catch (e) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[subscribe-interval-cards] subscribe-interval-cards:sync', e);
        }
      }
    });
  }

  // Capture phase: run before form-target listeners (e.g. product-subscriptions) so
  // data-selling-plan-id and card copy match the new format before selling plan sync.
  document.addEventListener(
    'variant:change',
    function (event) {
      const form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      const pr = getPickerAndSubscribeRoot(form);
      if (!pr.root) return;
      logSubscribe('event: variant:change (capture)', {
        formId: formIdAttr(form),
        detailVariantId: event.detail && event.detail.variant && event.detail.variant.id
      });
      syncSubscribeIntervalCardsUi(event.detail && event.detail.variant, form, 'variant:change');
    },
    true
  );

  // Bubble: run after VariantPicker handles the interval radio so master `id` matches the selection.
  document.addEventListener('change', function (event) {
    const t = event.target;
    if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;
    if (!t.name || !t.name.startsWith('option')) return;
    if (!t.closest('.subscribe-interval-cards')) return;
    const form = t.form || document.forms[t.getAttribute('form')];
    if (!form) {
      logSubscribe('event: change (interval radio) — no form', { name: t.name, formAttr: t.getAttribute('form') });
      return;
    }
    const fid = formIdAttr(form);
    const picker = document.querySelector('variant-picker[form="' + fid + '"]');
    const ms = picker && picker.masterSelector;
    const vid = ms && 'value' in ms ? ms.value : undefined;
    logSubscribe('event: change (interval radio)', {
      formId: fid,
      radioValue: t.value,
      masterValue: vid,
      masterIsElement: !!(ms && ms.nodeType === 1)
    });
    const variant =
      vid && picker?.product?.variants
        ? picker.product.variants.find(function (v) {
            return String(v.id) === String(vid);
          })
        : null;
    if (variant) {
      syncSubscribeIntervalCardsUi(variant, form, 'change:interval-radio');
    } else {
      logSubscribe('abort change:interval-radio: no variant for master id', { vid: vid, variantCount: picker?.product?.variants?.length });
    }
  });
})();


